import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const PDPWishlist = (props: IconProps) => (
  <Icon width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.58051 8.74701H0.667969V21.2072H22.3312V8.74701"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.667969 8.74701L2.25767 10.0139"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.15017 16.0008L1.03125 13.4834L4.85634 2.67834L21.9671 8.73474L21.82 9.15158"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.86035 3.74087L11.5015 1.20715L22.3311 8.747"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.667969 8.74701L3.29159 6.92029"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.3309 8.74701L13.9941 15.4082"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.667969 21.2071L11.5016 13.6714L22.3312 21.2071"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4997 10.7908C16.4909 10.463 15.4269 10.7957 14.7742 11.5504C14.69 10.5565 14.0246 9.66096 13.0165 9.3332C11.6729 8.89642 10.2309 9.63123 9.79408 10.9741C9.62984 11.4789 9.63126 11.9971 9.76789 12.4714C9.78771 12.54 9.81107 12.608 9.83655 12.6745C9.83655 12.6745 9.83868 12.6795 9.84151 12.6859C9.87478 12.7722 9.91443 12.8565 9.9569 12.9386C10.1926 13.4582 10.7306 14.6539 11.1504 15.6888C11.5801 16.8187 11.9971 18.0851 12.2137 19.2072C12.2137 19.2072 14.5335 17.1804 17.6455 15.6011C17.78 15.548 17.9096 15.4828 18.0335 15.4085C18.5403 15.102 18.9431 14.6199 19.1406 14.0125C19.5774 12.6696 18.8426 11.2269 17.4997 10.7908Z"
      fill="#DE271F"
      stroke="#131818"
      strokeWidth="0.6"
      strokeMiterlimit="10"
    />
  </Icon>
);
